const DashboardStyles = {
  listContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "1rem",
    paddingY: 3,
  },
  dashboardContainer: {
    minHeight: "100vh",
    p: { xs: 1, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  accordion: {
    background: "transparent",
    boxShadow: "none",
    border: "none",
    mb: 2,
  },
  accordionSummary: {
    background: "rgb(255, 255, 255)",
    borderRadius: 2,
    minHeight: 56,
    "&.Mui-expanded": { minHeight: 56 },
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;",
    mb: 2,
    px: 3,
    py: 1,
    display: "flex",
    alignItems: "center",
  },
  summaryContent: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: 22,
    ml: 1,
    mr: 2,
    display: "flex",
    alignItems: "center",
    lineHeight: 1, // Ensures vertical centering
  },
  itemCount: {
    borderRadius: 2,
    px: 1.5,
    py: 0.2,
    fontWeight: 500,
    fontSize: 14,
    ml: 1,
    display: "inline-flex",
    alignItems: "center",
    height: 32, // Ensures consistent height
  },
  accordionDetails: {
    borderRadius: 2,
    mt: 0,
    pt: 3,
    pb: 3,
    px: 2,
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr", // 1 card per row on extra small screens
      sm: "1fr 1fr", // 2 cards per row on small screens
      md: "1fr 1fr 1fr", // 3 cards per row on medium and up
      xl: "1fr 1fr 1fr 1fr",
    },
    gap: 3,
    width: "100%",
  },
  sectionIcon: {
    fontSize: 24,
    marginRight: "8px",
  },
};

export default DashboardStyles;
